/**
 * CommentReply Remapper
 * Flutter source: lib/data/models/comment_reply.dart
 */

import type { CommentReplyDto } from '@/data/dtos/comment/commentReplyDto';
import type { JsonObject } from '@/data/types/json';
import type { CommentReplyEntity } from '@/domain/entities/comment/commentReplyEntity';

export class CommentReplyRemapper {
  static fromJson(data: JsonObject): CommentReplyDto {
    return {
      replyId: (data['replyId'] as string | undefined) || '',
      userName: (data['userName'] as string | undefined) || '',
      userId: (data['userId'] as string | undefined) || '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): CommentReplyDto[] {
    return dataList.map(CommentReplyRemapper.fromJson);
  }

  static toEntity(dto: CommentReplyDto): CommentReplyEntity {
    return { ...dto };
  }

  static toDto(entity: CommentReplyEntity): CommentReplyDto {
    return { ...entity };
  }

  static toJson(dto: CommentReplyDto): JsonObject {
    return {
      replyId: dto.replyId,
      userName: dto.userName,
      userId: dto.userId,
    };
  }
}
